import { render, staticRenderFns } from "./TkPaymentOptions.vue?vue&type=template&id=07bc2be4&"
import script from "./TkPaymentOptions.vue?vue&type=script&lang=js&"
export * from "./TkPaymentOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports